import script from "./wechatAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./wechatAccount.vue?vue&type=script&setup=true&lang=js"

import "./wechatAccount.vue?vue&type=style&index=0&id=0b27971c&scoped=true&lang=stylus"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b27971c"]])

export default __exports__